import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PrintIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M21,18 C22.33,18 23,18.67 23,20 L23,24 C23,25.33 22.33,26 21,26 L11,26 C9.67,26 9,25.33 9,24 L9,20 C9,18.67 9.67,18 11,18 L21,18 Z M17,22 L12,22 L12,23 L17,23 L17,22 Z M21,5.5 C22.55,5.5 23.43,6.32 23.5,7.81 L23.5,11 L25,11 C26.33,11 27,11.67 27,13 L27,20 C27,21.33 26.33,22 25,22 L24,22 L24,20 C24,18 23,17 21,17 L11,17 C9,17 8,18 8,20 L8,22 L7,22 C5.67,22 5,21.33 5,20 L5,13 C5,11.67 5.67,11 7,11 L8.5,11 L8.5,8 C8.5,6.45 9.32,5.57 10.81,5.5 L21,5.5 Z M21,20 L12,20 L12,21 L21,21 L21,20 Z M23.5,13 C22.6715729,13 22,13.6715729 22,14.5 C22,15.3284271 22.6715729,16 23.5,16 C24.3284271,16 25,15.3284271 25,14.5 C25,13.6715729 24.3284271,13 23.5,13 Z M21,6.5 L11,6.5 C10,6.5 9.55,6.9 9.5,7.84 L9.5,11 L22.5,11 L22.5,8 C22.5,7 22.1,6.55 21.16,6.5 L21,6.5 Z"
        data-testid="icon-print"
        fill="#ffffff"
        className={styles.white}
        fillRule="nonzero"
      />
    </Icon>
  )
}
